import React from 'react';
import {ThemeContext} from '../theme/Theme.jsx'

import './OrderComment.scss';
import radium from 'radium';
import {connect} from "react-redux";
import LeoInput from '../../components/form/LeoInput.jsx';
import {checkoutChangeOrderComment} from "../../redux/checkoutPageReducer";
import ZigZagBox from "../zig-zag-box/ZigZagBox";
import {LEO_THEME} from "../../dev";
import formService from "../../lib/form-service.js";

function OrderComment(props) {
    const themeContext = React.useContext(ThemeContext);
    const themeModule = LEO_THEME.modules['shopping-cart'] || {};
    const orderCommentEnabled = themeModule['order-comment-enabled'] === 'true';

    const orderCommentTitle = themeContext.themeManager.getThemeTextOrHardcodedDefault("orderCommentTitle");
    const orderCommentPlaceholder = themeContext.themeManager.getThemeTextOrHardcodedDefault("orderCommentPlaceholder")

    return (
        <div>
            {orderCommentEnabled &&
                <div className="order_comment_container">
                    <ZigZagBox>
                        <label htmlFor="comment" className="leo__label order_comment_title" id={"order-label"}>{orderCommentTitle}</label>
                        <LeoInput
                            textarea={true}
                            maxLength="2000"
                            id="comment"
                            name="comment"
                            value={props.orderComment}
                            onChange={props.orderCommentChange}
                            placeholder={orderCommentPlaceholder}
                            errors={formService.findAddressErrorForField(props.orderCommentErrors,'comment', orderCommentTitle)}
                            label={orderCommentTitle}
                        />
                    </ZigZagBox>
                </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    const orderComment = state.checkoutPage.orderComment || ""
    return {
        orderComment,
        orderCommentErrors: state.eventPage.errors.filter(it => it.startsWith('order_comment_'))
            .map(it => it.replace('order_', ''))
    }
};

const mapDispatchToProps = (dispatch) => ({
    orderCommentChange: (event) => {
        //if(event.target.value)
        dispatch(checkoutChangeOrderComment(event.target.value));
    },
});

const RadiumOrderComment = radium(OrderComment);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RadiumOrderComment);
